/**
 * List Schema of CargaOpenlog
 * @author Simpli CLI generator
 */
import {
  Helper,
  Schema,
  FieldSet,
  FieldComponent,
  Component,
} from 'simpli-web-sdk'
import {CargaOpenlog} from '@/model/resource/CargaOpenlog'

/* TODO: review generated schema */
export class ListCargaOpenlogSchema extends Schema {
  readonly name = 'ListCargaOpenlog'

  readonly fieldSet: FieldSet<CargaOpenlog> = {
    idCodigoPk: (): FieldComponent => ({
      is: Component.Render,
    }),
    carga: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: schema.model.carga?.$id,
      },
    }),
    idPedido: (): FieldComponent => ({
      is: Component.Render,
    }),
  }
}
